import { IUpdateMaquinasEquipItensUseCase } from "../../../presentation/useCases/update/update_maquinas_equip_itens_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * UpdateMaquinasEquipItensUseCase
 */

export class UpdateMaquinasEquipItensUseCase implements IUpdateMaquinasEquipItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async updateMaquinasEquipItens(
    idItemMaquinaEquip: number,
    idMaquinaEquip: number,
    ordem: string,
    descricao: string,
  ): Promise<void> {
    await this.repository.updateControledePatrimonioMaquinasEquipItens(
      idItemMaquinaEquip,
      idMaquinaEquip,
      ordem,
      descricao,
    );
  }
}
